//action types
export const GET_DOCUMENT_LIST = 'GET_DOCUMENT_LIST';

//get 
export function getDocuments(data, callback) {
  return {
    type: GET_DOCUMENT_LIST,
    payload : {data, callback},
  };
}